import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useCart } from '../../context/CartContext';
import logo from '../../assets/images/logo/logo.png';
import logo2x from '../../assets/images/logo/logo_dark.png';
import menus from '../../pages/menu';
import './header-new.css';

const Header = () => {
    const [searchQuery, setSearchQuery] = useState('');
    const [mobileOpen, setMobileOpen] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const { cartItems, getCartCount } = useCart();
    const cartCount = getCartCount();

    const handleSearch = (e) => {
        e.preventDefault();
        if (searchQuery.trim()) {
            navigate(`/dt-shop?q=${encodeURIComponent(searchQuery)}`);
        }
    };

    const isActive = (path) => location.pathname === path;

    return (
        <header className="stan-header">
            <div className="stan-header-inner">
                {/* Mobile toggle */}
                <button
                    className="stan-mobile-toggle"
                    onClick={() => setMobileOpen(!mobileOpen)}
                    aria-label="Toggle menu"
                >
                    <span></span>
                    <span></span>
                    <span></span>
                </button>

                {/* Logo */}
                <Link to="/" className="stan-logo">
                    <img
                        src={logo}
                        srcSet={`${logo} 1x, ${logo2x} 2x`}
                        alt="D.T Wallet"
                        className="stan-logo-img"
                    />
                </Link>

                {/* Inline Nav */}
                <nav className="stan-nav-inline">
                    <ul className="stan-nav-list">
                        {menus.map((item) => (
                            <li
                                key={item.id}
                                className={`stan-nav-item ${item.namesub ? 'has-sub' : ''} ${isActive(item.links) ? 'active' : ''}`}
                            >
                                {item.namesub ? (
                                    <>
                                        <span className="stan-nav-link">
                                            {item.name}
                                            <span className="stan-nav-caret">▾</span>
                                        </span>
                                        <ul className="stan-nav-sub">
                                            {item.namesub.map((sub) => (
                                                <li key={sub.id}>
                                                    <Link to={sub.links}>{sub.sub}</Link>
                                                </li>
                                            ))}
                                        </ul>
                                    </>
                                ) : (
                                    <Link to={item.links} className="stan-nav-link">
                                        {item.name}
                                    </Link>
                                )}
                            </li>
                        ))}
                    </ul>
                </nav>

                {/* Search Bar */}
                <form className="stan-search-wrap" onSubmit={handleSearch}>
                    <span className="stan-search-icon">
                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                            <circle cx="11" cy="11" r="8" />
                            <line x1="21" y1="21" x2="16.65" y2="16.65" />
                        </svg>
                    </span>
                    <input
                        type="text"
                        className="stan-search-input"
                        placeholder="Search brands, vouchers..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                    />
                    <span className="stan-search-kbd">⌘K</span>
                </form>

                {/* Right Actions */}
                <div className="stan-actions">
                    {/* Country Selector */}
                    <div className="stan-country" role="button" tabIndex={0}>
                        <div className="stan-country-flag">
                            <div className="stan-country-flag-img">
                                <span style={{ background: '#FF9933' }}></span>
                                <span style={{ background: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <span style={{ width: '6px', height: '6px', borderRadius: '50%', background: '#000080', flex: 'none' }}></span>
                                </span>
                                <span style={{ background: '#138808' }}></span>
                            </div>
                        </div>
                        <span className="stan-country-arrow">▾</span>
                    </div>

                    {/* Orange Coin */}
                    <div className="stan-coin" role="button" tabIndex={0}>
                        <div className="stan-coin-icon orange">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="#fff">
                                <circle cx="12" cy="12" r="9" fill="#ff6b1a" stroke="#fff" strokeWidth="1.5" />
                                <text x="12" y="16" textAnchor="middle" fill="#fff" fontSize="10" fontWeight="bold">$</text>
                            </svg>
                        </div>
                        <span className="stan-coin-count">0</span>
                    </div>

                    {/* Yellow Coin */}
                    <div className="stan-coin" role="button" tabIndex={0}>
                        <div className="stan-coin-icon yellow">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="#fff">
                                <circle cx="12" cy="12" r="9" fill="#fdb827" stroke="#fff" strokeWidth="1.5" />
                                <text x="12" y="16" textAnchor="middle" fill="#000" fontSize="10" fontWeight="bold">★</text>
                            </svg>
                        </div>
                        <span className="stan-coin-count">0</span>
                    </div>

                    {/* Orders */}
                    <Link to="/cart" className="stan-action-btn">
                        <div className="stan-action-icon">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
                                <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
                                <line x1="12" y1="22.08" x2="12" y2="12" />
                            </svg>
                            {cartCount > 0 && (
                                <span className="stan-cart-badge">{cartCount}</span>
                            )}
                        </div>
                        <span className="stan-action-label">Orders</span>
                    </Link>

                    {/* Recharge */}
                    <Link to="/dashboard" className="stan-action-btn">
                        <div className="stan-action-icon">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                                <rect x="5" y="2" width="14" height="20" rx="2" ry="2" />
                                <line x1="12" y1="18" x2="12.01" y2="18" />
                            </svg>
                        </div>
                        <span className="stan-action-label">Recharge</span>
                    </Link>

                    {/* Profile */}
                    <Link to="/login" className="stan-action-btn">
                        <div className="stan-action-icon">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                                <circle cx="12" cy="12" r="10" />
                                <circle cx="12" cy="10" r="3.5" />
                                <path d="M5.5 19.5c1.5-3 4-4.5 6.5-4.5s5 1.5 6.5 4.5" />
                            </svg>
                        </div>
                        <span className="stan-action-label">Profile</span>
                    </Link>
                </div>
            </div>

            {/* Mobile Drawer (clone of inline nav for small screens) */}
            <div className={`stan-mobile-drawer ${mobileOpen ? 'open' : ''}`}>
                <ul className="stan-mobile-list">
                    {menus.map((item) => (
                        <li key={item.id}>
                            {item.namesub ? (
                                <>
                                    <span className="stan-mobile-link has-sub">
                                        {item.name}
                                        <span className="stan-nav-caret">▾</span>
                                    </span>
                                    <ul className="stan-mobile-sub">
                                        {item.namesub.map((sub) => (
                                            <li key={sub.id}>
                                                <Link to={sub.links} onClick={() => setMobileOpen(false)}>
                                                    {sub.sub}
                                                </Link>
                                            </li>
                                        ))}
                                    </ul>
                                </>
                            ) : (
                                <Link
                                    to={item.links}
                                    className="stan-mobile-link"
                                    onClick={() => setMobileOpen(false)}
                                >
                                    {item.name}
                                </Link>
                            )}
                        </li>
                    ))}
                </ul>
            </div>
        </header>
    );
};

export default Header;
